import React from 'react'

import Modal, {Footer, Header, Content} from "ui-components-rollup/dist/Modal";

export default ({closeTrigger, target, email = 'saas.support@netapp.com' , text = 'For any questions, contact us at', noChat}) => {
    const mailTo = `mailto:${email}`;
    const openIntercom = () => window.Intercom('show');
    return <Modal closeTrigger={closeTrigger} target={target}>
        <Header closeTrigger={closeTrigger}>
            Contact Us
        </Header>
        <Content>
            <p>{text} <a href={mailTo}>{email}</a> {!noChat && <span>or start a <button className="a" onClick={openIntercom}>chat</button> with us.</span>}</p>
        </Content>
        <Footer>
            <button onClick={closeTrigger}>OK</button>
        </Footer>
    </Modal>
};